<div id="login" class="inner-scroll" fxLayout="row" fxLayoutAlign="start">

    <div id="login-intro" fxFlex fxHide fxShow.gt-xs>

        <div class="logo" [@animate]="{value:'*',params:{scale:'0.2'}}">
            <img src="/assets/images/logos/logogro.png">
            <div class="title" [@animate]="{value:'*',params:{delay:'50ms',y:'25px'}}">
                <span class="name_title">e</span>.Justicia
            </div>
    
           <!--  <div class="description" [@animate]="{value:'*',params:{delay:'100ms',y:'25px'}}">
                Iniciamos una nueva era en la impartición de Justicia Administrativa
            </div> -->
        </div>

      

    </div>

    <div id="login-form-wrapper" fusePerfectScrollbar [@animate]="{value:'*',params:{delay:'300ms',x:'100%'}}">

        <div id="login-form">

            <div class="logo" fxHide.gt-xs>
                <img src="assets/images/logos/logogro.png">
            </div>
            <div class="title" [@animate]="{value:'*',params:{delay:'50ms',y:'25px'}}" fxHide.gt-xs>
                <span class="name_title">e</span>.Justicia
                <div class="h2 email">Administrativa Durango</div>
            </div>

            <div class="title">
                <div class="h2">INGRESA A TU CUENTA</div>
                <div class="h4" *ngIf="isAdvisorCitizen">Asesoría Ciudadana Administrativa en línea</div>
            </div>

            <form name="loginForm" [formGroup]="loginForm" novalidate>

                <mat-form-field appearance="outline">
                    <mat-label>Correo o Clave de Servidor</mat-label>
                    <input matInput formControlName="email" (keyup)="resetCredendtialError()">
                    <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                    <mat-error *ngIf="loginForm.get('email').hasError('required')">
                        Usuario es obligatorio
                    </mat-error>
                    <mat-error *ngIf="!loginForm.get('email').hasError('required') &&
                                loginForm.get('email').hasError('email')">
                        Por favor ingrese un correo valido
                    </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>Contraseña</mat-label>
                    <input matInput [type]="typePassword" formControlName="password" (keyup)="resetCredendtialError()">
                    <mat-icon matSuffix class="secondary-text" (click)="showPassword()" [title]="txt_tooltip_pass">vpn_key</mat-icon>
                    <mat-error>
                        Contraseña es obligatoria
                    </mat-error>
                </mat-form-field>

                <!--div class="remember-forgot-password" fxLayout="row" fxLayout.xs="column"
                    fxLayoutAlign="space-between center">
                    <mat-checkbox class="remember-me" aria-label="Remember Me">
                        Recordarme
                    </mat-checkbox>

                    <a class="forgot-password" [routerLink]="'/pages/auth/forgot-password'">
                        Olvidates tu contraseña?
                    </a>
                </div-->

                <button mat-raised-button color="accent" class="submit-button" aria-label="LOGIN" [disabled]="loginForm.invalid || loading" (click)="validCredential()">
                        INGRESAR
                    <div fxLayout="column" fxLayoutAlign="center center " *ngIf="loading">
                        <mat-progress-spinner
                            diameter="25"
                            mode="determinate"
                            [value]="valueLoading">
                        </mat-progress-spinner>
                    </div>
                </button>
                <a mat-stroked-button color="accent" class="submit-button" [disabled]="loading" [routerLink]="'/'">
                    CANCELAR
                </a>
                <mat-error fxLayout="column" fxLayoutAlign="center center" *ngIf="credentialError">
                    {{ msjError }}
                </mat-error>

            </form>

            <!--div class="separator">
                <span class="text">OR</span>
            </div>

            <div fxLayout="column" fxLayoutAlign="start center">

                <button mat-raised-button class="google">
                    Log in with Google
                </button>

                <button mat-raised-button class="facebook">
                    Log in with Facebook
                </button>

            </div-->

            <div class="register" fxLayout="column" fxLayoutAlign="center center">
                <span class="text">¿No tienes cuenta?</span>
                <a class="link" [routerLink]="'/pages/auth/register'" *ngIf="!isAdvisorCitizen">Crea una cuenta</a>
                <a class="link" [routerLink]="'/pages/auth/register/advisor-citizen'" *ngIf="isAdvisorCitizen">Crea una cuenta</a>
            </div>

            <div class="register mt-24" fxLayout="column" fxLayoutAlign="center center">
                <span class="text">¿Olvidaste contraseña?</span>
                <a class="link" [routerLink]="'/pages/auth/forgot-password'">Recupera contraseña</a>
            </div>
        </div>
    </div>
</div>